import { Card, Box, Tab, Tabs } from '@mui/material';
import { capitalCase } from 'change-case';
import { useTranslation } from 'react-i18next';
import useResponsive from '../../hooks/useResponsive';
import { useNavigate, useParams } from 'react-router';
import Page from '../../components/Page';
import ProductListing from './Tabs/ProductList';
import ProductFieldMapping from './Tabs/ProductFieldMapping';
import ProductSync from './Tabs/ProductSync';
import React from 'react';
import { SHOPLINE_NAVIGATION } from 'routes/paths';
import usePortalId from 'hooks/usePortalId';

export const PRODUCTS_TAB_NAMES = {
  PRODUCT_LISTING: 'product-listing',
  PRODUCT_FIELD_MAPPING: 'product-field-mapping',
  PRODUCT_SYNC: 'product-sync',
};
export default function Deals() {
  const { t } = useTranslation();
  const portalId = usePortalId();
  const smUp = useResponsive('up', 'sm');
  const navigate = useNavigate();

  const { tab } = useParams<{ tab: string }>();

  const PRODUCTS_TABS = React.useMemo(
    () => [
      {
        value: PRODUCTS_TAB_NAMES.PRODUCT_LISTING,
        icon: '',
        component: <ProductListing />,
      },
      {
        value: PRODUCTS_TAB_NAMES.PRODUCT_SYNC,
        icon: '',
        component: <ProductSync />,
      },
      {
        value: PRODUCTS_TAB_NAMES.PRODUCT_FIELD_MAPPING,
        icon: '',
        component: <ProductFieldMapping />,
      },
    ],
    []
  );

  return (
    <Page title={t('products')}>
      <Box>
        <Card sx={{ m: smUp ? 5 : 0, ml: smUp ? 8 : 0, p: 2 }}>
          <Tabs
            allowScrollButtonsMobile
            variant='scrollable'
            scrollButtons='auto'
            sx={{ ml: '30px' }}
            value={tab}
            onChange={(e, tabIndex) =>
              navigate(SHOPLINE_NAVIGATION.general.products(portalId, tabIndex))
            }
          >
            {PRODUCTS_TABS.map(tab => (
              <Tab
                disableRipple
                key={t(tab.value)}
                label={capitalCase(t(tab.value))}
                icon={tab.icon}
                value={tab.value}
              />
            ))}
          </Tabs>

          <Box sx={{ mb: 5 }} />

          {PRODUCTS_TABS.map(tabVal => {
            const isMatched = tabVal.value === tab;

            return (
              isMatched && <Box key={tabVal.value}>{tabVal.component}</Box>
            );
          })}
        </Card>
      </Box>
    </Page>
  );
}
